/* eslint @typescript-eslint/camelcase: 0 */

import {HcmRouteConfig} from "@/router";
import ProfileManagement from "@/components/pages/profile/ProfileManagement/index.vue";
import ProfileManagement_DataProfileTab from "@/components/pages/profile/ProfileManagement/DataProfileTab.vue";
import ProfileManagement_ServiceProfileTab from "@/components/pages/profile/ProfileManagement/ServiceProfileTab.vue";
import ProfileManagement_ContractProfileTemplateTab from "@/components/pages/profile/ProfileManagement/ContractProfileTemplateTab.vue";
import ProfileManagement_ServiceProfile from "@/components/pages/profile/ProfileManagement/ServiceProfile/index.vue";
import ProfileManagement_DataProfile from "@/components/pages/profile/ProfileManagement/DataProfile/index.vue";
import ProfileManagement_ContractProfileTemplate from "@/components/pages/profile/ProfileManagement/ContractProfileTemplate/index.vue";
import ProfileSearch from "@/components/pages/profile/ProfileSearch/index.vue";
import ProfileSearch_OwnerCustomer from "@/components/pages/profile/ProfileSearch/OwnerCustomerTab.vue";
import ProfileSearch_DataProfile from "@/components/pages/profile/ProfileSearch/DataProfileTab.vue";
import ProfileSearch_PublicTradeContract from "@/components/pages/profile/ProfileSearch/PublicTradeContractTab.vue";
import ViewContract from "@/components/pages/contract/TradeContract/ViewContract/index.vue";

const routes: HcmRouteConfig[] = [
  /********************************************************************************************************************
   * プロファイル管理
   ********************************************************************************************************************/

  // プロファイル管理
  {
    path: '/profileManagement',
    name: '/profileManagement',
    component: ProfileManagement,
    meta: {
      label: 'プロファイル管理',
      parent: 'Home',
      permissions: ['contract'],
    },
    children: [{
      path: 'dataProfiles',
      name: '/profileManagement/dataProfiles',
      component: ProfileManagement_DataProfileTab
    }, {
      path: 'serviceProfiles',
      name: '/profileManagement/serviceProfiles',
      component: ProfileManagement_ServiceProfileTab
    }, {
      path: 'contractProfileTemplates',
      name: '/profileManagement/contractProfileTemplates',
      component: ProfileManagement_ContractProfileTemplateTab
    }]
  }, {
    path: '/profileManagement/serviceProfile/:serviceProfileId',
    name: '/profileManagement/serviceProfile',
    component: ProfileManagement_ServiceProfile,
    props: true,
    meta: {
      label: 'サービスプロファイル閲覧',
      parent: '/profileManagement/serviceProfiles',
      permissions: ['contract'],
      isOwnedServiceProfile: true,
    }
  }, {
    path: '/profileManagement/dataProfile/:dataProfileId',
    name: '/profileManagement/dataProfile',
    component: ProfileManagement_DataProfile,
    props: true,
    meta: {
      label: 'データプロファイル閲覧',
      parent: '/profileManagement/dataProfiles',
      permissions: ['contract'],
      isOwnedDataProfile: true,
    }
  }, {
    path: '/profileManagement/contractProfileTemplate/:contractProfileTemplateId',
    name: '/profileManagement/contractProfileTemplate',
    component: ProfileManagement_ContractProfileTemplate,
    props: true,
    meta: {
      label: '契約プロファイル',
      parent: '/profileManagement/contractProfileTemplates',
      permissions: ['contract'],
    }
  },

  // プロファイル照会
  {
    path: '/profileSearch',
    name: '/profileSearch',
    component: ProfileSearch,
    meta: {
      label: 'プロファイル照会',
      parent: 'Home',
      permissions: ['contract'],
    },
    children: [{
      name: '/profileSearch/customers',
      path: 'customers',
      component: ProfileSearch_OwnerCustomer
    }, {
      name: '/profileSearch/dataProfiles',
      path: 'dataProfiles',
      component: ProfileSearch_DataProfile
    }, {
      name: '/profileSearch/publicTradeContracts',
      path: 'publicTradeContracts',
      component: ProfileSearch_PublicTradeContract
    }]
  }, {
    path: '/profileSearch/dataProfiles/:dataProfileId',
    name: '/profileSearch/dataProfiles/browse',
    component: ProfileManagement_DataProfile,
    props: true,
    meta: {
      label: 'データプロファイル閲覧',
      parent: '/profileSearch/dataProfiles',
      permissions: ['contract'],
      isOwnedDataProfile: false,
    }
  }, {
    path: '/profileSearch/publicTradeContracts/:tradeContractId',
    name: '/profileSearch/publicTradeContracts/browse',
    component: ViewContract,
    props: true,
    meta: {
      label: '募集中の取引契約閲覧',
      parent: '/profileSearch/publicTradeContracts',
      permissions: ['contract'],
      isAssetsTradeContract: true,
    }
  },
];

export default routes;
